import Player from "@/player/player";

import saveTime from "./functions/save-time";
import setPoster from "./functions/set-poster";
import setControls from "./functions/custom-controls";
import lazyLoad from "./functions/lazy-load";
import analytics from "./functions/analytics";
import stickyPlayer from "./functions/sticky-player";
import customLogo from "./functions/custom-logo";
import actions from "./functions/actions";
import ajaxProgress from "./functions/ajax-progress";
import classes from "./functions/classes";
import fullscreen from "./functions/fullscreen";
import menuSizing from "./functions/menu-sizing";
import youtubeFixes from "./functions/youtube-fixes";

/**
 * Get things going
 *
 * @param {HTMLElement} element
 */
export default function (element, options = {}) {
  const setup = {
    ...options,
    ...{
      iconUrl: `${window?.prestoPlayer?.plugin_url}img/sprite.svg`,
    },
    ...{
      chapters: options?.chapters || [],
      controls: options?.controls || [],
      settings: Object.keys(options?.settings || {}).length
        ? options.settings
        : {},
    },
  };

  let player = new Player(element, setup);

  // conditionally load learndash
  if (typeof learndash_video_data !== "undefined") {
    import("../integrations/learndash").then((module) => {
      const learnDash = module.default;
      learnDash(player);
    });
  }

  actions(player);
  ajaxProgress(player);
  classes(player);
  youtubeFixes(player);
  fullscreen(player);
  menuSizing(player);
  customLogo(player);
  lazyLoad(player);
  setPoster(player);
  setControls(player);

  // if we're in the admin, don't do the rest of these.
  if (prestoPlayer.isAdmin) {
    return player;
  }

  // non-admin stuff
  saveTime(player);
  analytics(player);
  stickyPlayer(player);

  return player;
}
